import React from "react";
import useAuth from "$hooks/useAuth";
import { Button } from "$components";

type AdminCreateButtonProps = {
  onClick: () => void;
  children: React.ReactNode;
};

// reusable component
// named create button but can be used for anything
export default function AdminCreateButton({
  onClick,
  children,
}: AdminCreateButtonProps) {
  const { isAdmin } = useAuth();

  if (!isAdmin()) return null;
  return (
    <Button
      color="secondary"
      variant="contained"
      onClick={onClick}
      style={{ padding: 0, minWidth: 40 }}
    >
      {children}
    </Button>
  );
}
